module.exports = __webpack_public_path__ + "img/img_5_five_intelligence@3x.5e7bdead.png";